import CsatByHourOfDayWidget from './CsatByHourOfDayWidget';
export default CsatByHourOfDayWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CsatByHourOfDayWidget/index.js